var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.id
    ? _c(
        "div",
        { staticClass: "googlemap" },
        [
          _c(
            "gmap-map",
            {
              ref: _vm.id,
              style: _vm.mapStyle,
              attrs: { id: _vm.id, center: _vm.center, zoom: 10 },
            },
            [
              _vm._l(_vm.markers, function (m, index) {
                return _c("gmap-marker", {
                  key: index,
                  attrs: {
                    position: m.position,
                    clickable: true,
                    draggable: false,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.openInfoWindowTemplate()
                    },
                  },
                })
              }),
              _vm._v(" "),
              _c(
                "gmap-info-window",
                {
                  attrs: {
                    options: _vm.infoWindow.options,
                    position: _vm.infoWindow.position,
                    opened: _vm.infoWindow.open,
                  },
                  on: {
                    closeclick: function ($event) {
                      _vm.infoWindow.open = false
                    },
                  },
                },
                [_c("div", { domProps: { innerHTML: _vm._s(_vm.info) } })]
              ),
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }